export const environment = {
    baseUrl:
        window.origin !== undefined
            ? window.origin
            : window.location.protocol +
              '//' +
              window.location.hostname +
              (window.location.port ? ':' + window.location.port : ''),
};
